import React, { forwardRef } from 'react';
import capitalize from 'lodash/capitalize';
import BaseButton from './BaseButton';

const RecycleBinButton = forwardRef(({ title = 'Recycle Bin', value, onShow, onHide, name, ...props }, ref) => {
  const onClick = value ? onHide : onShow;
  const buttonTitle = value ? `${capitalize(name)} Grid` : title;
  const icon = value ? 'grid-layout' : 'trash';
  return (
    <BaseButton
      ref={ref}
      id='recycle-bin-button'
      onClick={onClick}
      icon={icon}
      tooltip={buttonTitle}
      themeColor='light'
      {...props}
    />
  );
});

export default RecycleBinButton;
